import { lazy, Suspense, useEffect, useState } from "react";
import { connect } from "react-redux";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { bindActionCreators } from "redux";
import {
  AUTH_USER,
  UN_AUTH_USER,
} from "../src/components/screen/login/redux/loginReducer";
import LoadingJs from "./components/common/loadingJs";
import ErrorBoundary from "./components/common/ErrorBoundary";
import Layout from "./components/layout/menuv2/LayoutV2";
import DefaultRoute from "./components/routes/default-route";
import PrivateRoute from "./components/routes/private-route";
import PublicRoute from "./components/routes/public-route";
import { CookiesHelper } from "./share/base/common/cookiesHelper";
import { closeLoading, openLoading } from "./share/base/common/LoadingAction";
import { loginType } from "./share/base/constants/login";
import "./share/css/App.scss";
import "./share/css/mobile-responsive.scss";
import { compData } from "./AppData";
import CommonBase from "./share/base/network/axiosNetwork";
import { SET_MENUS } from "./components/screen/login/redux/menuReducer";
import { menuApi, userInforApi } from "./share/base/constants/constApi";
const Login = lazy(() => import("./components/screen/login/login"));
// sinh ra string
// const IndexUser = lazy(() =>
//   import("./components/screen/AdminManager/Home/IndexUser")
// );
function App(props) {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let login = CookiesHelper.get(loginType.loginCookieName);
    if (login !== undefined && login !== null) {
      props.loginAction.AUTH_USER(JSON.parse(login));
      getInforUserService();
      getMenuService();
    } else {
      props.loginAction.UN_AUTH_USER();
    }
    setIsLoading(false);
    return () => {};
  }, []);

  const getInforUserService = async () => {
    openLoading();
    let response = await CommonBase.getAsync(userInforApi);
    if (response.isSuccess) {
      let login = JSON.parse(CookiesHelper.get(loginType.loginCookieName));
      let data = { token: login.token, userInfo: response.data };
      props.loginAction.AUTH_USER(data); // set token vao header
    }
    closeLoading();
  };

  const getMenuService = async () => {
    openLoading();
    let response = await CommonBase.getAsync(menuApi);
    if (response.isSuccess) {
      // set menu vao reducer
      props.menuAction.SET_MENUS(response.data);
    }
    closeLoading();
  };
  return (
    <ErrorBoundary>
      <div className="h-100">
        {isLoading === true ? (
          <div></div>
        ) : (
          <BrowserRouter
            basename={process.env.PUBLIC_URL}
            fallback={<div>Loading...</div>}
          >
            <LoadingJs />
            <Suspense>
              <Switch>
                <DefaultRoute exact path="/" />
                <PublicRoute exact path="/dang-nhap" RouteComp={Login} />
                <PublicRoute exact path="/dang-ky" RouteComp={Login} />
                <Layout exact>
                  {compData && compData.length > 0
                    ? compData.map((item, index) => (
                        <PrivateRoute
                          key={index}
                          exact
                          path={item.path}
                          RouteComp={item.compPath}
                        />
                      ))
                    : null}
                </Layout>
              </Switch>
            </Suspense>
            <ToastContainer />
          </BrowserRouter>
        )}
      </div>
    </ErrorBoundary>
  );
}

const mapDispatchToProps = (dispatch) => ({
  // homeAction: bindActionCreators({ AUTH_USER, UN_AUTH_USER }, dispatch),
  loginAction: bindActionCreators({ AUTH_USER, UN_AUTH_USER }, dispatch),
  menuAction: bindActionCreators({ SET_MENUS }, dispatch),
});

export default connect(null, mapDispatchToProps)(App);
